import { render, staticRenderFns } from "./basecost-setting-list.vue?vue&type=template&id=4c320f1e"
import script from "./basecost-setting-list.vue?vue&type=script&lang=ts"
export * from "./basecost-setting-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports